module.exports = __webpack_public_path__ + "img/1090216419.73196b93.jpg";